import Banner from "../../component/homepage/banner";
import Header from "../../component/homepage/header";
const Homepage = () => {
  return (
    <>
      <Header />
      <Banner />
    </>
  );
};
export default Homepage;
